function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwinCentral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499999 6.3500002",
    id: "svg134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect136",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 0.00052917,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 1.9711127,0.28397387 h 2.80633 V 6.1304948 h -2.80633 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 2.2216779,0.20162685 v 5.98015495 0",
    id: "path965-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.15875,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "0.3175, 0.635",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "m 1.3822844,0.25173978 v 5.84652042 0",
    id: "path965-86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 3.509087,0.65847895 A 0.33408686,0.35914345 0 0 1 3.1750001,1.0176224 0.33408686,0.35914345 0 0 1 2.840913,0.65847895 0.33408686,0.35914345 0 0 1 3.1750001,0.29933545 0.33408686,0.35914345 0 0 1 3.509087,0.65847895 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008-1",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 3.5090869,5.5792521 A 0.33408686,0.35914345 0 0 1 3.1750001,5.9383955 0.33408686,0.35914345 0 0 1 2.840913,5.5792521 0.33408686,0.35914345 0 0 1 3.1750001,5.2201087 0.33408686,0.35914345 0 0 1 3.5090869,5.5792521 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 0.52618681,0.18492257 v 5.98015483 0",
    id: "path965-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1008-2",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264584,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "M 3.5090869,3.1070083 A 0.33408686,0.35914345 0 0 1 3.1750001,3.4661518 0.33408686,0.35914345 0 0 1 2.840913,3.1070083 0.33408686,0.35914345 0 0 1 3.1750001,2.7478649 0.33408686,0.35914345 0 0 1 3.5090869,3.1070083 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 5.8674014,0.18374815 v 5.98015495 0",
    id: "path965-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.15875,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "0.3175, 0.635",
      strokeDashoffset: 0,
      strokeOpacity: 0.51
    },
    d: "m 4.9277818,0.28397387 v 5.84652033 0",
    id: "path965-86-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.264583,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.51
    },
    d: "m 4.1134451,0.16704387 v 5.98015483 0",
    id: "path965-0-0-9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinCentral);
export default __webpack_public_path__ + "static/media/TwinCentral.3745934883c2d7fd85a5b9017735fc5f.svg";
export { ForwardRef as ReactComponent };